import MessageComponent from '../MessageComponent.vue'

export default [
    {
        path: '/messages',
        name: 'Messages',
        meta: { layout: 'default' },
        component: MessageComponent,
    },
]